export const MENU_ITEMS = [
  { key: 'header.item.home', label: 'Inicio', path: '/' },
  { key: 'header.item.web', label: 'Web', path: 'https://www.alsothere.com/' },
  { key: 'header.item.faq', label: 'FAQ', path: '/faq' },
  { key: 'header.item.contact', label: 'Contacto', path: 'mailto:hola@alsothere.com' },
];

export const SCHEDULE_URL =
  'https://calendar.google.com/appointments/schedules/AcZssZ2zJc6MQ01WNg-Vn44kVGvQGMMo2ZiKIHciphmK6F__IErnKyJMwKwJamGqgoaXOfHdsJRUajVf';

export const EMAIL_CONTACT = 'pangex@alsothere.com';
